import {InputTextV2} from '@prtimes-basis/input';
import {Button} from '@prtimes-basis/button';
import styles from './zip-field.module.css';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

type Props = {
  readonly onAutoFillAddress: () => void;
};

export function ZipField({onAutoFillAddress}: Props) {
  return (
    <FormField.Root name='billingInfo.zip'>
      <div className={styles.container}>
        <div className={styles.zipContainer}>
          <Body />

          <Button
            style={{height: '100%'}}
            variant='flat'
            onClick={onAutoFillAddress}
          >
            住所入力
          </Button>
        </div>

        <FormField.Error />

        <span className={styles.overseasNote}>
          FOR OVERSEAS CUSTOMERS：Please enter [0000000] in the postal code
          field.
        </span>
      </div>
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField();

  return (
    <>
      <label
        htmlFor={fieldProps.id}
        className={companyRegistrationPageStyles.srOnly}
      >
        請求先住所（郵便番号）
      </label>
      <div className={styles.zipField}>
        <InputTextV2 placeholder='郵便番号' {...fieldProps} />
      </div>
    </>
  );
}
